import { API_BASE_URL } from '../config';
import api from './axiosInstance';

// Vista OFICIAL No-Clientes: endpoints /NoClients/* que leen las TABLAS NUEVAS
// (cruce + transcripcion). Reemplaza al noClientsService viejo (tablas viejas).

export const getNoClientsDemoPaged = async ({
  page = 1,
  pageSize = 10,
  sortBy = null,
  desc = null,
  search = null,
  signal,
} = {}) => {
  try {
    const params = { page, pageSize };
    if (sortBy) params.sortBy = sortBy;
    if (desc !== null && desc !== undefined) params.desc = desc;
    if (search && String(search).trim()) params.search = String(search).trim();

    const response = await api.get(`${API_BASE_URL}/NoClients/lost-deals`, {
      params,
      signal,
    });
    return response.data;
  } catch (error) {
    console.error('getNoClientsDemoPaged failed:', error);
    throw error;
  }
};

// Detalle de un cliente: todas sus llamadas concretadas (Feeling/Summary por llamada).
export const getNoClientsDemoCallsByDeal = async (dealId, signal) => {
  try {
    const response = await api.get(
      `${API_BASE_URL}/NoClients/lost-deals/${encodeURIComponent(dealId)}/calls`,
      { signal }
    );
    return response.data;
  } catch (error) {
    console.error('getNoClientsDemoCallsByDeal failed:', error);
    throw error;
  }
};

// Transcripcion + metadatos de una llamada (por ConnId).
export const getNoClientsDemoTranscript = async (connId, signal) => {
  try {
    const response = await api.get(
      `${API_BASE_URL}/NoClients/calls/${encodeURIComponent(connId)}/transcript`,
      { signal }
    );
    return response.data;
  } catch (error) {
    console.error('getNoClientsDemoTranscript failed:', error);
    throw error;
  }
};

// Evaluacion de protocolo de la llamada (por ConnId). Devuelve { protocolId, lostReason, analysisJson }.
export const getNoClientsDemoProtocolAnalysis = async (connId, signal) => {
  try {
    const response = await api.get(
      `${API_BASE_URL}/NoClients/calls/${encodeURIComponent(connId)}/protocol-analysis`,
      { signal }
    );
    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) return null; // aun no analizada
    console.error('getNoClientsDemoProtocolAnalysis failed:', error);
    throw error;
  }
};

// Analisis comercial CONSOLIDADO del cliente (veredicto unico de sus llamadas de venta).
// SOLO LECTURA: lo precalcula el proceso batch / job. 404 => aun no calculado (null).
export const getNoClientsConsolidatedAnalysis = async (dealId, signal) => {
  try {
    const response = await api.get(
      `${API_BASE_URL}/NoClients/lost-deals/${encodeURIComponent(dealId)}/consolidated-analysis`,
      { signal }
    );
    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) return null; // aun no calculado
    console.error('getNoClientsConsolidatedAnalysis failed:', error);
    throw error;
  }
};

// Hilo de EMAIL del cierre (ordenado por fecha). 404 => sin hilo (null).
export const getNoClientsEmailThread = async (dealId, signal) => {
  try {
    const response = await api.get(
      `${API_BASE_URL}/NoClients/lost-deals/${encodeURIComponent(dealId)}/email-thread`,
      { signal }
    );
    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) return null; // sin hilo de email
    console.error('getNoClientsEmailThread failed:', error);
    throw error;
  }
};

// Hilo de WHATSAPP del cierre (ordenado por fecha). 404 => sin hilo (null).
export const getNoClientsWhatsappThread = async (dealId, signal) => {
  try {
    const response = await api.get(
      `${API_BASE_URL}/NoClients/lost-deals/${encodeURIComponent(dealId)}/whatsapp-thread`,
      { signal }
    );
    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) return null; // sin hilo de whatsapp
    console.error('getNoClientsWhatsappThread failed:', error);
    throw error;
  }
};

// URL firmada (presigned) del audio de la llamada, reproducible inline (por ConnId).
export const getNoClientsDemoAudioUrl = async (connId, signal) => {
  try {
    const response = await api.get(
      `${API_BASE_URL}/NoClients/calls/${encodeURIComponent(connId)}/audio-url`,
      { signal }
    );
    return response.data?.url || null;
  } catch (error) {
    console.error('getNoClientsDemoAudioUrl failed:', error);
    throw error;
  }
};
